import happySvg    from '../assets/images/happy.svg';
import coolSvg     from '../assets/images/cool.svg';
import okSvg       from '../assets/images/ok.svg';
import worriedSvg  from '../assets/images/worried.svg';
import loveSvg     from '../assets/images/love.svg';
import finishedSvg from '../assets/images/finished.svg';

const MOODS = [
  { src: happySvg,    title: 'Game start',    sub: "Let's go!" },
  { src: coolSvg,     title: 'At par',        sub: 'Nailed it 😎' },
  { src: okSvg,       title: '1–3 over par',  sub: 'Not bad' },
  { src: worriedSvg,  title: '4–6 over par',  sub: 'Getting tense…' },
  { src: loveSvg,     title: 'Beat par',       sub: "You're a genius!" },
  { src: finishedSvg, title: 'Solved!',        sub: 'Well done' },
];

export default function MoodStrip() {
  return (
    <div className="mood-strip-wrapper" role="list" aria-label="Mascot moods">
      <div className="mood-strip">
        {MOODS.map((mood, i) => (
          <div key={i} className="mood-item" role="listitem">
            <img src={mood.src} alt={`${mood.title} — ${mood.sub}`} />
            <div className="mood-label">
              <strong>{mood.title}</strong>
              {mood.sub}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
